import CoreTable from '@/components/Table';
import { useCoreContext } from '@/core';
import React from 'react';
import { TableColumn } from '../../components';
import { get } from 'lodash';
import { Typography } from 'antd';
import { CorePagination } from '@/components/Pagination';
import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';

export const CourseLineTable = () => {
  const { loading, error, courseLineData, setValue, getValues } = useCoreContext();
  const { handleClickEdit } = useHandleActionItem();

  const tableColumns = TableColumn({
    onSelectItem: (id) => {
      handleClickEdit({ id });
    },
  });

  return (
    <>
      {error && <div>Error</div>}
      {!error && (
        <div>
          <CoreTable
            columns={tableColumns}
            dataSource={get(courseLineData, 'data') ?? []}
            tableName='Course Line'
            loading={loading}
          />
          <div className='flex mt-4 justify-between'>
            <Typography.Title level={3}>
              Total: {get(courseLineData, 'count') > 999 ? '>= 1000' : get(courseLineData, 'count')}
            </Typography.Title>
            <CorePagination
              total={get(courseLineData, 'count') ?? 0}
              defaultPageSize={10}
              showSizeChanger
              pageSizeOptions={['5', '10', '20']}
              onChange={(page, pageSize) => {
                setValue('page', page);
                setValue('limit', pageSize);
              }}
              current={getValues('page')}
            />
          </div>
        </div>
      )}
    </>
  );
};
